import { OnSchedRest } from "../OnSchedRest";
import { OnSchedUtils } from "../utils";

import { FindCustomer,
         CreateCustomer,
         UpdateCustomer  }   from "./customerActions";


export const CreateAppointment = (element, payload) => new Promise((resolve, reject) => {
  const { onsched, options } = element;

  let url = onsched.apiBaseUrl + '/appointments';
  
  // Complete Booking
  // if (options.completeBooking) {
    // If Complete Booking is BK or RS, add query parameter
    if (options.completeBooking && options.completeBooking !== 'IN') {
      url += '?completeBooking=' + options.completeBooking;
    }

    // Customer SMS
    if (options.customerSMS) {
      let customerPayload = {};

      // Customer ID
      if (options.customerId || options.fields?.email) {
        if (options.customerId) {
          customerPayload.id = options.customerId;
        }
        else {
          customerPayload.email = options.fields?.email;
        }

        // Search customers - exists
        FindCustomer(element, customerPayload).then(customer => {
          if (customer) {
            payload.customerId = customer.id;
            
            const customerPayload = OnSchedUtils.FormatCustomerNotificationType(element, customer);

            // If Notification Type was updated, update the customer
            if (customer.notificationType === "0" || customer.notificationType === "1" || customerPayload.contact?.mobilePhone) {
              UpdateCustomer(element, customerPayload)
                .then(() => OnSchedRest.Post(url, OnSchedUtils.FormatApptPayload(element, payload), resolve));
            }
            else {
              // Book Appointment
              OnSchedRest.Post(url, OnSchedUtils.FormatApptPayload(element, payload), resolve)
            }
          }
          else {
            // Create Customer with Email & SMS
            CreateCustomer(element, { notificationType: '3' })
              .then(customerCreated => {
                // Book and skip
                payload.customerId = customerCreated.id;
                OnSchedRest.Post(url, OnSchedUtils.FormatApptPayload(element, payload), resolve)
              })
          }
        });
      }
      // Neither
      else {
          // Booking form empty
          url = url.split('?')[0];
          OnSchedRest.Post(url, payload, resolve);
      }
    }
    else {
    // NO CUSTOMER SMS
      // Customer ID
      if (options.customerId) {
        // Book and skip
        payload.customerId = options.customerId;
        OnSchedRest.Post(url, OnSchedUtils.FormatApptPayload(element, payload), resolve);
      }
      // Customer Info
      else if (options.fields?.email) {
        // Check customer info
        payload = Object.assign(payload, OnSchedUtils.FormatCustomerAppointmentPayload(element));
        // Book and skip
        OnSchedRest.Post(url, OnSchedUtils.FormatApptPayload(element, payload), resolve);
      }
      // Neither
      else {
        // Booking form empty
        url = url.split('?')[0];
        OnSchedRest.Post(url, payload, resolve);
      }
    }
})

export const BookAppointment = (element, id, payload) => new Promise((resolve, reject) => {
  OnSchedRest.Put(element.onsched.apiBaseUrl + '/appointments/' + id + '/book', payload, response => {
    OnSchedUtils.CustomEvents(element.id, 'bookingConfirmation', response);
    OnSchedUtils.CheckErrors({element, data: response}).then(resolve);
  })
})

export const RescheduleAppointment = (element, id, payload) => new Promise((resolve, reject) => {
  OnSchedRest.Put(element.onsched.apiBaseUrl + '/appointments/' + id + '/reschedule', payload, response => {
    OnSchedUtils.CheckErrors({element, data: response}).then(resolve);
  })
})

export const ConfirmAppointment = (element, id) => new Promise((resolve, reject) => {
  let url = element.onsched.apiBaseUrl + '/appointments/' + id + '/confirm';

  if (element.options.hasOwnProperty('confirm')) {
    url += '?undo=' + !element.options.confirm;
  }

  OnSchedRest.Put(url, {}, response => {
    OnSchedUtils.CustomEvents(element.id, 'bookingConfirmation', response);
    OnSchedUtils.CheckErrors({element, data: response}).then(resolve);
  })
})

export const DeleteAppointment = (element, appointmentId) => new Promise(resolve => {
  OnSchedUtils.Loading(element, true);
    
  OnSchedRest.Delete(element.onsched.apiBaseUrl + '/appointments/' + appointmentId, response => {
    if (response.error) {
      OnSchedUtils.CheckErrors({element, data: response});
    }
    else {
      OnSchedUtils.Loading(element, false);
      resolve(response);
    }
  });
})